import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

export default class Checkbox extends React.PureComponent {
    static propTypes = {
        /** The id given to the input and label's htmlFor */
        id: PropTypes.string.isRequired,

        /** The content of the label (usually just text) */
        label: PropTypes.node.isRequired,

        /** Name of the input */
        name: PropTypes.string,

        /** Internal value of the input */
        value: PropTypes.string,

        /** If the checkbox is checked */
        isChecked: PropTypes.bool,

        /** If the checkbox is disabled */
        isDisabled: PropTypes.bool,

        /** If the checkbox is disabled */
        isInvalid: PropTypes.bool,

        /** If the checkbox is required */
        isRequired: PropTypes.bool,

        /** The ref to be passed to the input */
        innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),

        /** Additional className applied to the wrapping element */
        className: PropTypes.string,

        /** If false, the label will be screen reader only */
        isLabelVisible: PropTypes.bool
    };

    static defaultProps = {
        isDisabled: false,
        innerRef: undefined,
        className: undefined,
        isChecked: undefined,
        isLabelVisible: true
    };

    render() {
        const {
            id,
            label,
            value,
            name,
            isDisabled,
            isChecked,
            isRequired,
            isInvalid,
            innerRef,
            className,
            onChange,
            defaultChecked,
            isLabelVisible,
            ...otherProps
        } = this.props;

        return (
            <label
                htmlFor={id}
                ref={innerRef}
                className={cx("rec-label-checkbox", {
                    disabled: isDisabled,
                    [className]: className
                })}
                {...otherProps}>
                <input
                    type="checkbox"
                    id={id}
                    value={value}
                    name={name}
                    disabled={isDisabled}
                    required={isRequired}
                    className="rec-input-hide"
                    checked={isChecked}
                    onChange={onChange}
                    defaultChecked={defaultChecked} />
                <span className={cx("rec-input-checkbox", {
                    "is-invalid": isInvalid
                })} />
                {isLabelVisible ? label : (<span className="rec-sr-only">{label}</span>)}
            </label>
        );
    }
}
